// extracted by mini-css-extract-plugin
export default {"payPalButtonImg":"QU8nwLwaOJjT_iG6nN7Y","checkbox":"QIDep2fNPi4u6mU_kRno","payPalButton":"wekR_O03W7erMDpkwlmA","payPalButtonDisabled":"_Bq5gO2lQTvHwZ6tY4TC"};